// Embedded translation data
// All translations are embedded directly to avoid runtime fetch issues

export const translations = {
  en: {
    hero: {
      eyebrow: "For personal trainers & online coaches",
      headline: {
        part1: "The AI writes ",
        part2: "next week's plans.",
        part3: "You approve them",
        part4: "."
      },
      subheadline: "Stop rewriting plans every Sunday. Trainzilla keeps every client's training and diet adjusted to their check-ins — and you stay in control of every change.",
      features: {
        plans: "Builds & edits real plans",
        actions: "Reschedules sessions, messages clients",
        insight: "Reads recovery & run history",
        approve: "You approve every change"
      },
      stats: {
        actions: "Actions the agent takes",
        surfaces: "Web · iOS · Android · Client",
        approval: "Changes you approve",
        specialties: "Coaching specialties"
      },
      cta: {
        watchVideo: "Watch the agent work",
        getApp: "Get Coach App",
        clientApp: "Your Clients Get a Free Mobile App!"
      }
    },
    cta: {
      badge: "Join 150+ Early Adopter Coaches",
      title: "Ready to Transform",
      titleAccent: "Your Coaching Business?",
      subtitle: "Stop juggling spreadsheets and apps. Start using AI to automate busywork, delight your clients, and scale your fitness business globally.",
      benefitRevenue: "Accelerated Revenue",
      benefitRevenueSub: "Scale your business faster",
      benefitCapacity: "10x Client Capacity",
      benefitCapacitySub: "With AI automation",
      benefitGlobal: "Serve Clients Worldwide",
      benefitGlobalSub: "Remote & in-person",
      startTrial: "Start Free Trial",
      scheduleDemo: "Schedule a Demo",
      clientAppLink: "Your clients get the TrainZilla Coach App:",
      finePrintNoCard: "No credit card required",
      finePrintTrial: "Free for 30 days",
      finePrintCancel: "Cancel anytime",
      finePrintSupport: "Help chat any time"
    },
    solutions: {
      badge: "Solutions for Every Business",
      title: "Tailored for",
      titleAccent: "Any Fitness Business",
      subtitle: "Personal trainers, gym owners, fitness studios — TrainZilla grows with you.",
      forPersonalTrainers: "For Personal Trainers",
      forGymOwners: "For Gym Owners",
      forFitnessStudios: "For Fitness Studios",
      forCorporateWellness: "For Corporate Wellness",
      trustBadge: "Trusted by Fitness Professionals Worldwide",
      readyTitle: "Ready to Transform Your Business?",
      readySubtitle: "Join 150+ early adopter fitness professionals growing with TrainZilla.",
      viewSuccessStories: "View Success Stories",
      personalTrainers: {
        label: "Personal Trainers",
        desc: "Grow your personal training business with professional tools designed for independent coaches.",
        item1: { title: "Client Management Made Easy", desc: "Organize and track all your clients in one place with detailed profiles and progress monitoring.", features: ["Client profiles", "Progress tracking", "Session history", "Communication tools"] },
        item2: { title: "Grow Your Business", desc: "Scale your personal training business with tools designed for growth and efficiency.", features: ["Business analytics", "Revenue tracking", "Client retention", "Performance metrics"] },
        item3: { title: "Save Time & Efficiency", desc: "Automate routine tasks and focus on what matters most — training your clients.", features: ["Automated scheduling", "Workout templates", "Progress reports", "Payment processing"] },
        item4: { title: "Deliver Better Results", desc: "Provide exceptional service with professional tools and personalized experiences.", features: ["Custom workout plans", "Progress visualization", "Goal tracking", "Achievement badges"] }
      },
      gymOwners: {
        label: "Gym Owners",
        desc: "Manage your facility with comprehensive tools for operations, staff, and member management.",
        item1: { title: "Multi-Trainer Management", desc: "Manage multiple trainers and their clients from a centralized dashboard.", features: ["Trainer oversight", "Client allocation", "Performance monitoring", "Schedule coordination"] },
        item2: { title: "Business Intelligence", desc: "Make data-driven decisions with comprehensive business analytics and insights.", features: ["Revenue analytics", "Member retention", "Equipment utilization", "Staff performance"] },
        item3: { title: "Member Experience", desc: "Enhance member satisfaction with professional service and modern technology.", features: ["Member app", "Class booking", "Progress tracking", "Community features"] },
        item4: { title: "Operational Excellence", desc: "Streamline operations with automated systems and professional management tools.", features: ["Automated billing", "Staff scheduling", "Equipment maintenance", "Compliance tracking"] }
      },
      fitnessStudios: {
        label: "Fitness Studios",
        desc: "Create a premium boutique experience with tools for small group training and community building.",
        item1: { title: "Boutique Experience", desc: "Create a personalized studio experience that keeps members coming back.", features: ["Class management", "Member profiles", "Booking system", "Waitlist management"] },
        item2: { title: "Community Building", desc: "Foster a strong community culture with social features and engagement tools.", features: ["Community feed", "Group challenges", "Achievement sharing", "Member spotlights"] },
        item3: { title: "Instructor Tools", desc: "Empower your instructors with professional tools for better class delivery.", features: ["Class planning", "Attendance tracking", "Performance feedback", "Schedule management"] },
        item4: { title: "Brand Management", desc: "Build and maintain your studio brand with professional marketing tools.", features: ["Custom branding", "Email marketing", "Social integration", "Referral programs"] }
      },
      corporateWellness: {
        label: "Corporate Wellness",
        desc: "Implement employee wellness programs that boost productivity and satisfaction.",
        item1: { title: "Program Management", desc: "Design and manage comprehensive corporate wellness programs.", features: ["Program templates", "Goal setting", "Progress tracking", "Reporting dashboard"] },
        item2: { title: "Scalable Solutions", desc: "Deploy wellness programs across multiple locations and departments seamlessly.", features: ["Multi-location support", "Department management", "Custom branding", "Admin controls"] },
        item3: { title: "Remote Wellness", desc: "Support remote and hybrid employees with virtual wellness programs.", features: ["Virtual sessions", "Home workout plans", "Digital check-ins", "Flexible scheduling"] },
        item4: { title: "Compliance & Security", desc: "Ensure data privacy and compliance with corporate wellness regulations.", features: ["HIPAA compliance", "Data encryption", "Privacy controls", "Audit trails"] }
      },
      yogaInstructors: {
        label: "Yoga Instructors",
        desc: "Professional tools for yoga and mindfulness instructors to manage students and classes.",
        item1: { title: "Class & Student Management", desc: "Organize your yoga studio or private classes with intuitive student profiles and history.", features: ["Student attendance", "Class history", "Medical history tracking", "Membership status"] },
        item2: { title: "Digital Yoga Programs", desc: "Create and share digital yoga sequences and mindfulness programs with your students.", features: ["Sequence builder", "Video library", "Meditation guides", "Progress journals"] },
        item3: { title: "Automated Scheduling", desc: "Allow students to book classes and private sessions online with ease.", features: ["Class calendar", "Private booking", "Automatic reminders", "Waitlist management"] },
        item4: { title: "Payments & Invoicing", desc: "Get paid on time with automated billing and secure local payment support.", features: ["UPI integration", "Digital receipts", "Membership renewals", "Income reports"] }
      }

    },
    scheduleDemo: {
      badge: "Free 30-min demo",
      title: "Schedule Your Personal Demo",
      subtitle: "Get a personalized walk-through of TrainZilla tailored to your fitness business.",
      pillTime: "30 minutes",
      pillLive: "Live demo",
      pillPersonalized: "Personalized",
      successHeader: "Demo Scheduled! 🎉",
      successDesc: "Our team will contact you within 24 hours to confirm your demo time.",
      requestId: "Request ID",
      signUpNow: "Sign Up Now",
      fullName: "Full Name",
      email: "Email",
      businessType: "Business Type",
      phone: "Phone",
      preferredTime: "Preferred Time",
      optional: "(Optional)",
      fullNamePlaceholder: "Your full name",
      emailPlaceholder: "your.email@company.com",
      businessPlaceholder: "Select business type",
      timePlaceholder: "Any time",
      scheduling: "Scheduling…",
      submitButton: "Schedule Demo",
      businessTypes: {
        personal: "Personal Trainer",
        gym: "Gym Owner",
        studio: "Fitness Studio",
        wellness: "Wellness Center",
        corporate: "Corporate Fitness",
        other: "Other"
      },
      timeSlots: {
        morning: "Morning (9 AM – 12 PM)",
        afternoon: "Afternoon (12 PM – 5 PM)",
        evening: "Evening (5 PM – 8 PM)",
        flexible: "Any time works"
      }
    },
    common: {
      app: {
        name: "TrainZilla",
        tagline: "Empower Your Fitness Business"
      },
      navigation: {
        solutions: "Solutions",
        platformOverview: "Platform Overview",
        clientManagement: "Client Management",
        workoutPlanning: "Workout Planning",
        progressTracking: "Progress Tracking",
        nutritionPlanning: "Nutrition Planning",
        businessAnalytics: "Business Analytics",
        forCoaches: "For Coaches",
        personalTrainers: "Personal Trainers",
        fitnessCenters: "Fitness Centers",
        yogaInstructors: "Yoga Instructors",
        nutritionists: "Nutritionists",
        corporateWellness: "Corporate Wellness",
        pricing: "Pricing",
        clientApp: "Client App",
        resources: "Resources",
        helpCenter: "Help Center",
        trainingVideos: "Training Videos",
        successStories: "Success Stories",
        blog: "Blog",
        webinars: "Webinars",
        sitemap: "Sitemap",
        aiFeatures: "AI Features",
        mobileCoachApp: "Mobile Coach App",
        pricingAndPlans: "Pricing & Plans",
        contactSupport: "Contact Support",
        aboutUs: "About Us"
      },
      actions: {
        signIn: "Sign In",
        signOut: "Sign Out",
        signUp: "Sign Up",
        getStarted: "Get Started",
        startFreeTrial: "Start Free Trial",
        scheduleDemo: "Schedule Demo",
        contactSales: "Contact Sales",
        learnMore: "Learn More",
        download: "Download",
        upload: "Upload",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        update: "Update",
        submit: "Submit",
        close: "Close",
        back: "Back",
        next: "Next",
        confirm: "Confirm",
        search: "Search",
        filter: "Filter",
        sort: "Sort",
        export: "Export",
        import: "Import",
        print: "Print",
        share: "Share",
        copy: "Copy",
        viewDetails: "View Details",
        coachApp: "Coach App",
        downloadCoachApp: "Download TrainZilla Coach",
        downloadOn: "Download on the",
        appStore: "App Store",
        getItOn: "Get it on",
        googlePlay: "Google Play"
      },
      common: {
        yes: "Yes",
        no: "No",
        ok: "OK",
        loading: "Loading...",
        saving: "Saving...",
        success: "Success",
        error: "Error",
        warning: "Warning",
        info: "Information",
        required: "Required",
        optional: "Optional",
        all: "All",
        none: "None",
        other: "Other",
        or: "or",
        and: "and",
        of: "of",
        in: "in",
        at: "at",
        by: "by",
        from: "from",
        to: "to",
        with: "with"
      },
      time: {
        day: "Day",
        days: "Days",
        week: "Week",
        weeks: "Weeks",
        month: "Month",
        months: "Months",
        year: "Year",
        years: "Years",
        today: "Today",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        now: "Now",
        ago: "ago",
        justNow: "Just now"
      },
      footer: {
        company: "Company",
        product: "Product",
        support: "Support",
        legal: "Legal",
        followUs: "Follow Us",
        allRightsReserved: "TrainZilla Technologies. All rights reserved.",
        privacyPolicy: "Privacy Policy",
        termsOfService: "Terms of Service",
        refundPolicy: "Refund Policy",
        brandText: "The AI-powered platform helping 150+ early adopter fitness coaches automate plan updates, manage clients, and scale their business.",
        platform: "Platform",
        solutions: "Solutions",
        resources: "Resources",
        global: "Worldwide · priced in INR and USD",
        soon: "Soon"
      },
      region: {
        selectRegion: "Select Region",
        currentRegion: "Current Region",
        changeRegion: "Change Region",
        popularRegions: "Popular Regions",
        otherRegions: "Other Regions",
        global: "Global",
        regionNotice: "Pricing shown for {{region}} ({{currency}}) - All prices are converted from our base pricing. You can change your region using the selector in the header."
      },
      language: {
        selectLanguage: "Select Language",
        currentLanguage: "Current Language",
        changeLanguage: "Change Language",
        popularLanguages: "Popular Languages",
        otherLanguages: "Other Languages"
      },
      errors: {
        generic: "Something went wrong. Please try again.",
        networkError: "Network error. Please check your connection.",
        notFound: "Not found",
        unauthorized: "Unauthorized access",
        forbidden: "Access forbidden",
        validationError: "Please check your input",
        serverError: "Server error. Please try again later."
      }
    },
    pricing: {
    newPricing: {
    "header": {
        "title": "Choose how you want to ",
        "titleHighlight": "launch",
        "titleEnd": " with Trainzilla",
        "subtitle": "Start free for 30 days, then move to Coach Pro when you're ready to take on more clients. No setup fees, no lock-in.",
        "trustedBy": "Trusted by coaches who build results and businesses."
    },
    "tiers": {
        "freeLaunch": {
            "name": "Free Launch",
            "forWho": "For coaches testing online coaching",
            "price": "₹0",
            "priceSub": "Free for 30 days",
            "includes": "Includes:",
            "features": [
                "Coach profile",
                "1 paid offer",
                "Basic client invite link",
                "Basic marketplace listing",
                "Limited client slots",
                "Trainzilla branding"
            ],
            "button": "LAUNCH FREE",
            "footer": "Start without risk. Upgrade when you're ready to manage more clients."
        },
        "coachPro": {
            "name": "Coach Pro",
            "forWho": "For active coaches managing clients",
            "price": "₹499",
            "pricePeriod": "/month",
            "includes": "Includes everything in Free, plus:",
            "features": [
                "Multiple paid offers",
                "Client app access",
                "Your logo, name & colours in the client app",
                "Your own domain for profile & checkout",
                "Workout & nutrition tools",
                "Check-ins",
                "Progress tracking",
                "Payment link support",
                "Client messaging",
                "Priority marketplace listing",
                "Basic analytics"
            ],
            "button": "START PRO",
            "footer": "Best for coaches who already have clients and need a professional system."
        }
    },
    "comparison": {
        "headers": {
            "features": "Features"
        },
        "rows": [
            {
                "name": "Coach Profile",
                "f": "true",
                "p": "true"
            },
            {
                "name": "Paid Offers / Packages",
                "f": "1",
                "p": "Unlimited"
            },
            {
                "name": "Client Slots",
                "f": "Limited",
                "p": "Unlimited"
            },
            {
                "name": "Client App",
                "f": "true",
                "p": "true"
            },
            {
                "name": "Workout & Nutrition Tools",
                "f": "Basic",
                "p": "true"
            },
            {
                "name": "Check-ins & Progress",
                "f": "false",
                "p": "true"
            },
            {
                "name": "Marketplace Visibility",
                "f": "Basic",
                "p": "Priority"
            },
            {
                "name": "Payment Link Support",
                "f": "Basic",
                "p": "true"
            },
            {
                "name": "Analytics",
                "f": "false",
                "p": "Basic"
            },
            {
                "name": "Setup & Growth Support",
                "f": "Self-serve",
                "p": "Templates & Guides"
            },
            {
                "name": "Branded Client App (your logo, name & colours)",
                "f": "false",
                "p": "true"
            }
        ]
    },
    "bottomFeatures": [
        {
            "title": "Start today",
            "desc": "Sign up and invite your first client in minutes."
        },
        {
            "title": "Cancel Anytime",
            "desc": "No long-term lock-in."
        },
        {
            "title": "Secure Payments",
            "desc": "Trusted & hassle-free."
        },
        {
            "title": "Made for Coaches",
            "desc": "By coaches, for coaches."
        }
    ],
    "sidebar": {
        "title": "Why coaches choose Trainzilla",
        "items": [
            {
                "title": "More Professional Presence",
                "desc": "Build trust with a verified coach page."
            },
            {
                "title": "Convert More Leads",
                "desc": "Turn followers & DMs into paying clients."
            },
            {
                "title": "Save Time",
                "desc": "Automate check-ins, payments & follow-ups."
            },
            {
                "title": "Scale Your Revenue",
                "desc": "Package better, sell better, and grow consistently."
            }
        ],
        "footer": [
            "Verified Coaches.",
            "Real Transformations.",
            "Bigger Business."
        ]
    }
},
      title: "Choose the Perfect Plan for Your Business",
      subtitle: "Try it free for 30 days with your first client. No credit card required. Cancel anytime.",
      launchOffer: {
        title: "Limited Time Launch Offer!",
        discount: "Get 50% OFF on All Plans",
        subtitle: "Launch Celebration Pricing!",
        description: "Join early and lock in this special discount forever. Offer valid for first 100 trainers only!"
      },
      billingCycle: {
        monthly: "Monthly",
        yearly: "Yearly",
        saveUpTo: "Save up to {{percent}}%"
      },
      plans: {
        starter: {
          name: "Starter",
          description: "Perfect for new trainers starting their journey",
          popular: false
        },
        professional: {
          name: "Professional",
          description: "Ideal for established trainers and small gyms",
          popular: true
        },
        enterprise: {
          name: "Enterprise",
          description: "Complete solution for gyms and fitness businesses",
          popular: false
        }
      },
      features: {
        unlimitedClients: "Unlimited clients",
        workoutBuilder: "Workout Builder",
        nutritionBuilder: "Nutrition Builder",
        personalizedWebpage: "Personalized Webpage",
        marketplaceEnrollment: "Marketplace Enrollment",
        sessionBooking: "Online/Offline Session Booking",
        automatedPayments: "Automated Payments",
        analytics: "Business and Client Analytics",
        mobileApp: "Free Client iOS and Android App",
        whiteLabel: "White Label Custom App",
        apiIntegrations: "API Integrations (Zapier, etc.)",
        videoConsultations: "Video Consultations",
        customBranding: "Custom Branding",
        advancedAnalytics: "Advanced Analytics Dashboard",
        prioritySupport: "Priority Support",
        marketingTools: "Automated Marketing Tools",
        multiTenant: "Multi-Tenant Architecture",
        adminDashboard: "Admin Role & Dashboard Overview",
        multiLocation: "Multi-Location Management",
        multiTrainer: "Multi-Trainer Management",
        staffRoles: "Staff Role Management",
        centralReporting: "Centralized Reporting",
        dedicatedManager: "Dedicated Account Manager",
        support24x7: "Priority Support",
        customFeatures: "Custom Feature Development",
        advancedSecurity: "Advanced Security Features",
        customOnboarding: "Custom Onboarding & Training",
        slaGuarantee: "SLA Guarantee"
      },
      cta: {
        startTrial: "Start Free Trial Now",
        contactSales: "Contact Sales",
        scheduleDemo: "Schedule Demo"
      },
      perMonth: "/month",
      perYear: "/year",
      save: "Save {{amount}}/month",
      billedAnnually: "Billed annually ({{amount}})",
      mostPopular: "Most Popular",
      launchDiscount: "50% LAUNCH DISCOUNT!",
      whatsIncluded: "What's included:",
      notIncluded: "Not included:",
      comparison: {
        title: "Compare All Plans",
        features: "Features",
        clients: "Number of Clients",
        videoConsultations: "Video Consultations",
        customBranding: "Custom Branding",
        apiAccess: "API Access",
        support: "Support",
        supportEmail: "Email",
        supportPriority: "Priority",
        supportDedicated: "Dedicated"
      },
      faq: {
        title: "Frequently Asked Questions",
        changePlans: {
          question: "Can I change plans later?",
          answer: "Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately."
        },
        freeTrial: {
          question: "What happens after the free trial?",
          answer: "After 30 days, upgrade to Coach Pro (₹499/month in India, $19/month elsewhere) to keep onboarding clients. Your account and data stay intact, and nothing is billed until you choose to upgrade."
        },
        setupFee: {
          question: "Is there a setup fee?",
          answer: "No setup fees! All plans include free onboarding and setup assistance."
        },
        cancel: {
          question: "Can I cancel anytime?",
          answer: "Yes, you can cancel your subscription at any time. No long-term contracts or cancellation fees."
        },
        payouts: {
          question: "How do I get paid by my clients?",
          answer: "Clients pay you directly: in India to your UPI ID (GPay, PhonePe, Paytm), elsewhere on your own Stripe, PayPal or Wise link. You confirm each payment in Trainzilla and their plan starts. The money never passes through Trainzilla and we take no cut."
        },
        paymentMethods: {
          question: "What payment methods are accepted?",
          answer: "We accept all major payment methods including UPI, credit/debit cards, net banking, and digital wallets."
        }
      },
      customSolution: {
        title: "Need a Custom Solution?",
        description: "For large gyms, fitness chains, or custom requirements, contact our sales team for a personalized quote.",
        callSales: "Call Sales: {{phone}}",
        email: "Email: {{email}}"
      },
      trialCta: {
        title: "Start Your Free Trial Today",
        description: "Set up your coach profile and try TrainZilla free for 30 days with your first client. No credit card required."
      },
      clientAppCta: {
        title: "Your Clients Get a Free Mobile App!",
        description: "Every TrainZilla subscription includes a FREE mobile app for your clients. They can track workouts, follow nutrition plans, book sessions, and chat with you - all from their smartphone.",
        features: {
          platforms: "iOS & Android",
          free: "100% Free",
          noAds: "No Ads",
        },
        learnMore: "Learn About Client App"
      },
      downloadGuide: {
        title: "Download Complete Pricing Guide",
        description: "Get a detailed PDF with all pricing information, feature comparisons, and ROI calculations to help you choose the right plan for your fitness business.",
        button: "Download Pricing Guide",
        note: "The guide includes ROI calculations and comparison with competitors"
      },
      guidePdf: {
        title: "TrainZilla Pricing Guide",
        subtitle: "Complete pricing information for personal trainers and fitness businesses - LAUNCH OFFER: 50% OFF!",
        launchOffer: {
          title: "🎉 Special Launch Offer - 50% OFF All Plans!",
          p1: "To celebrate our launch, we're offering an incredible 50% discount on all TrainZilla plans!",
          p2: "This is a limited-time offer for the first 100 trainers who join our platform.",
          p3: "Lock in this special pricing forever - your rate will never increase as long as you maintain your subscription."
        },
        overview: {
          title: "Overview of TrainZilla Plans",
          p1: "TrainZilla offers three comprehensive plans designed to meet the needs of personal trainers at different stages of their business journey.",
          p2: "All plans include core features for client management, workout planning, and business growth tools."
        },
        plans: {
          starter: {
            title: "Starter Plan - ₹499/month (Originally ₹998/month)",
            save: "SAVE ₹499/month with our launch discount!",
            desc: "Perfect for new trainers starting their fitness business"
          },
          pro: {
            title: "Professional Plan - ₹999/month (Originally ₹1,998/month) - Most Popular",
            save: "SAVE ₹999/month with our launch discount!",
            desc: "Ideal for established trainers and small fitness businesses",
            note: "NOTE: One-time setup from ₹25,000 for custom app & integrations"
          },
          enterprise: {
            title: "Enterprise Plan - ₹1,999/month (Originally ₹3,998/month)",
            save: "SAVE ₹1,999/month with our launch discount!",
            desc: "Complete solution for gyms and large fitness businesses",
            note: "NOTE: One-time setup from ₹50,000 based on requirements"
          }
        },
        annual: {
          title: "Annual Pricing Benefits",
          p1: "Save even more with annual billing - combine the 50% launch discount with annual savings!",
          p2: "Annual plans provide budget predictability and additional cost savings for growing businesses.",
          pricingTitle: "Annual Plan Pricing (with 50% Launch Discount)",
          starter: "Starter Plan: ₹4,990/year (Originally ₹9,980/year) - Save ₹4,990!",
          pro: "Professional Plan: ₹9,990/year (Originally ₹19,980/year) - Save ₹9,990!",
          enterprise: "Enterprise Plan: ₹19,990/year (Originally ₹39,980/year) - Save ₹19,990!"
        },
        included: {
          title: "What's Included in Every Plan",
          p1: "All TrainZilla plans include fundamental features that every personal trainer needs to run a successful business.",
          p2: "No hidden fees or setup costs - everything you need is included in your monthly subscription.",
          coreTitle: "Core Features (All Plans)",
          f1: "Client management and progress tracking",
          f2: "Workout plan creation and customization",
          f3: "Session scheduling and automated reminders",
          f4: "Payment processing and billing management",
          f5: "Mobile app for trainers and clients",
          f6: "Secure data storage and backup",
          f7: "Regular software updates and improvements",
          supportTitle: "Support and Onboarding",
          s1: "Free setup assistance and onboarding",
          s2: "Training materials and documentation",
          s3: "Video tutorials in Hindi and English",
          s4: "Community support forum access",
          s5: "Regular webinars and training sessions"
        },
        custom: {
          title: "Custom Solutions and Enterprise Support",
          p1: "For fitness chains, large gyms, or businesses with unique requirements, TrainZilla offers custom solutions.",
          p2: "Contact our sales team to discuss specific needs and get a personalized quote.",
          featuresTitle: "Custom Features Available",
          f1: "White-label branding with your business logo and colors",
          f2: "Custom integrations with existing business systems",
          f3: "Advanced reporting and analytics dashboards",
          f4: "Multi-location management for fitness chains",
          f5: "Custom mobile app development",
          f6: "Dedicated infrastructure and enhanced security",
          contactTitle: "Contact Information",
          phone: "Sales Phone: +91 84596 91471",
          email: "Email: sales@trainzilla.in",
          web: "Schedule a demo at: trainzilla.app",
          response: "Response time: Within 2 business hours for all inquiries"
        }
      }
    },
    featuresPage: {
      headers: {
        platformBadge: "Platform Features",
        platformTitle: "Everything You Need to",
        platformHighlight: "Scale Your Coaching",
        platformSubtitle: "A complete toolkit for fitness professionals — from client management to automated scheduling.",
        aiBadge: "AI-Powered",
        aiTitle: "Work Smarter with",
        aiHighlight: "TrainZilla AI",
        aiSubtitle: "Leverage advanced artificial intelligence to automate programming and deliver better results.",
        videoBadge: "Communication",
        videoTitle: "Connect Anywhere with",
        videoHighlight: "Video & Chat",
        videoSubtitle: "Break geographical limitations and train clients anywhere in the world.",
        mobileBadge: "Mobile App",
        mobileTitle: "Your Coaching Business",
        mobileHighlight: "in Your Pocket",
        mobileSubtitle: "Manage your business and connect with clients anytime, anywhere.",
        analyticsBadge: "Analytics",
        analyticsTitle: "Data-Driven",
        analyticsHighlight: "Business Growth",
        analyticsSubtitle: "Make informed decisions with comprehensive analytics and reporting."
      },
      categories: {
        platform: {
          clientManagement: {
            title: "Client Management",
            description: "Manage your entire client base with detailed profiles, progress tracking, and communication tools.",
            f1: "Client profiles", f2: "Progress tracking", f3: "Communication hub", f4: "Payment management"
          },
          workoutPlans: {
            title: "Workout Plans",
            description: "Create custom workout routines tailored to each client's goals and fitness level.",
            f1: "Exercise library", f2: "Custom routines", f3: "Progress tracking", f4: "Video demonstrations"
          },
          progressTracking: {
            title: "Progress Tracking",
            description: "Monitor client progress with detailed analytics and performance metrics.",
            f1: "Performance metrics", f2: "Progress photos", f3: "Body measurements", f4: "Achievement badges"
          },
          sessionScheduling: {
            title: "Session Scheduling",
            description: "Streamline booking with automated scheduling and reminders across time zones.",
            f1: "Online booking", f2: "Automated reminders", f3: "Calendar sync", f4: "Waitlist management"
          }
        },
        ai: {
          workoutRecs: {
            title: "AI Workout Recommendations",
            description: "Smart algorithm suggests personalized workouts based on client goals and performance.",
            f1: "Personalized suggestions", f2: "Adaptive programming", f3: "Goal optimization", f4: "Performance analysis"
          },
          goalSetting: {
            title: "Intelligent Goal Setting",
            description: "AI-powered goal setting that adapts to client progress and preferences.",
            f1: "Smart goal recommendations", f2: "Progress predictions", f3: "Milestone tracking", f4: "Achievement optimization"
          }
        },
        video: {
          consultations: {
            title: "Video Consultations",
            description: "Conduct virtual training sessions with high-quality video calling.",
            f1: "HD video calls", f2: "Screen sharing", f3: "Session recording", f4: "Multi-participant support"
          },
          communication: {
            title: "Real-time Communication",
            description: "Stay connected with clients through instant messaging and notifications.",
            f1: "Instant messaging", f2: "Push notifications", f3: "Group chats", f4: "File sharing"
          }
        },
        mobile: {
          appAccess: {
            title: "Mobile App Access",
            description: "Full-featured mobile app for trainers and clients on iOS and Android.",
            f1: "iOS & Android apps", f2: "Offline access", f3: "Push notifications", f4: "Sync across devices"
          },
          sync: {
            title: "Cross-platform Sync",
            description: "Seamless synchronization across all devices and platforms.",
            f1: "Real-time sync", f2: "Cloud storage", f3: "Multi-device access", f4: "Backup & restore"
          }
        },
        analytics: {
          business: {
            title: "Business Analytics",
            description: "Comprehensive business insights and performance analytics.",
            f1: "Revenue tracking", f2: "Client retention", f3: "Session analytics", f4: "Performance metrics"
          },
          reports: {
            title: "Performance Reports",
            description: "Detailed reports on client progress and business performance.",
            f1: "Custom reports", f2: "Client progress", f3: "Business metrics", f4: "Export options"
          }
        }
      }
    },
    clientAppPage: {
      hero: {
        badge: "Free for All Fitness Enthusiasts",
        title1: "Your Fitness Journey",
        title2: "Starts Here",
        subtitle: "Follow your coach's plan, log workouts and meals, and track your progress, all in one free app.",
        downloadAppStore: "Download on the App Store",
        downloadPlayStore: "Get it on Google Play",
        ratingText: "100% Free · No Ads · Works with your coach"
      },
      stats: {
        activeUsers: "Active Users",
        trainers: "Coaches",
        workouts: "Workouts Tracked",
        rating: "App Rating"
      },
      featuresSection: {
        badge: "Powerful Features",
        title: "Everything You Need for Fitness Success",
        subtitle: "All-in-one platform to find trainers, track workouts, monitor nutrition, and achieve your goals.",
        items: {
          marketplace: { title: "Trainer's Marketplace", desc: "Discover certified personal trainers in your area. Browse profiles, read reviews, compare packages, and find your perfect fitness match." },
          subscribe: { title: "Subscribe to Plans", desc: "Choose and subscribe to trainer packages that fit your goals and budget. Flexible payment options with UPI, cards, and wallets." },
          workout: { title: "Workout Tracking", desc: "Access personalized workout plans created by your trainer. Track sets, reps, and weights. View exercise videos and GIFs for proper form." },
          nutrition: { title: "Nutrition Tracking", desc: "Follow customized meal plans from your trainer. Track calories, macros, and water intake. Get healthy recipe suggestions." },
          progress: { title: "Progress Analytics", desc: "Document your fitness journey with photos, measurements, and body stats. Visualize your progress with beautiful charts and graphs." },
          chat: { title: "Secure Chat", desc: "Direct messaging with your trainer for quick questions and support. Share progress photos, ask for form checks, and stay motivated." },
          booking: { title: "Session Booking", desc: "Book online video sessions or offline in-person training. Sync with your calendar, get reminders, and manage your fitness schedule effortlessly." },
          secure: { title: "Safe & Secure", desc: "Your data is encrypted and protected. Payments are processed securely through Razorpay, and your data is encrypted in transit." }
        }
      },
      howItWorks: {
        badge: "Simple Process",
        title: "Get Started in 4 Easy Steps",
        subtitle: "Your fitness transformation is just a few taps away",
        step1: { title: "Download the App", desc: "Get TrainZilla Client from the App Store or Google Play. Sign up in seconds with your email or phone number." },
        step2: { title: "Find Your Trainer", desc: "Browse the marketplace, filter by location, specialty, ratings, and price. Read reviews and check trainer credentials." },
        step3: { title: "Subscribe to a Plan", desc: "Choose a package that fits your goals and budget. Subscribe securely with UPI, cards, or digital wallets." },
        step4: { title: "Start Your Journey", desc: "Access workouts, track nutrition, book sessions, and chat with your trainer. Watch your progress soar!" }
      },
      cta: {
        badge: "Free for clients",
        title: "Ready to Transform Your Body?",
        subtitle: "Free on iPhone and Android. Download it, connect with your coach and start today.",
        noCreditCard: "No Credit Card Required",
        freeApp: "100% Free App",
        cancelAnytime: "Cancel Memberships Anytime",
        floatingButton: "Download App"
      }
    },
    helpCenterPage: {
      hero: {
        badge: "Support Center",
        title: "How can we help you today?",
        subtitle: "Search our knowledge base, explore guides, or contact our support team.",
        searchPlaceholder: "Search for articles, tutorials, or topics...",
        searchButton: "Search"
      },
      categories: {
        title: "Browse by Topic",
        viewAll: "View all",
        articlesInCollection: "{{count}} articles in this collection",
        noResults: "No results found",
        noResultsMsg: "We couldn't find any articles matching \"{{term}}\". Try a different keyword.",
        gettingStarted: {
          title: "Getting Started",
          desc: "Setup your account and start using TrainZilla",
          a1: "How to set up your trainer profile",
          a2: "Creating your first workout template",
          a3: "Inviting clients to the platform",
          a4: "Configuring your calendar availability",
          a5: "Downloading the mobile app"
        },
        accountSettings: {
          title: "Account & Settings",
          desc: "Manage your profile, subscription, and preferences",
          a1: "Changing your account email or password",
          a2: "Upgrading or downgrading your subscription",
          a3: "Managing notification preferences",
          a4: "Setting your primary currency and timezone",
          a5: "Exporting client data"
        },
        billing: {
          title: "Billing & Payments",
          desc: "Invoicing, payments, and financial reports",
          a1: "Setting up Stripe or PayPal integration",
          a2: "How to create automated recurring invoices",
          a3: "Handling international client payments",
          a4: "Understanding platform transaction fees",
          a5: "Downloading invoices for tax compliance"
        },
        features: {
          title: "Platform Features",
          desc: "Deep dive into TrainZilla's powerful tools",
          a1: "Using AI to generate tailored nutrition plans",
          a2: "Creating multilingual workout programs",
          a3: "Tracking client progress metrics over time",
          a4: "Setting up habit tracking and streaks",
          a5: "Managing clients across different time zones"
        }
      },
      quickActions: {
        faq: { title: "FAQs", desc: "Quick answers to common questions", action: "View FAQs" },
        chat: { title: "Live Chat", desc: "Chat with our global support team", action: "Start Chat" },
        email: { title: "Email Support", desc: "Get a response within 24 hours", action: "Email Us" },
        video: { title: "Video Guides", desc: "Watch step-by-step tutorials", action: "Watch Videos" },
        docs: { title: "Documentation", desc: "Complete platform reference", action: "Read Docs" }
      },
      popularArticles: {
        title: "Popular Articles",
        views: "{{count}} views",
        a1: { title: "Setting up international payments with Stripe", category: "Payments" },
        a2: { title: "Creating multilingual workout plans with AI", category: "Workout Planning" },
        a3: { title: "Managing clients across different time zones", category: "Client Management" },
        a4: { title: "Understanding global tax compliance for digital fitness", category: "Billing" },
        a5: { title: "Automating client onboarding workflows", category: "Automation" },
        a6: { title: "Syncing TrainZilla with Apple Health & Google Fit", category: "Integrations" },
        a7: { title: "Customizing your branded client app experience", category: "Branding" },
        a8: { title: "Running group challenges and bootcamps", category: "Features" }
      },
      contactBanner: {
        title: "Still Need Help?",
        subtitle: "Ask the Help chat in your coach app any time, or reach us by WhatsApp, phone or email.",
        btnSupport: "Contact Support",
        availableGlobally: "Available globally in 12+ international languages"
      }
    },
    contactUsPage: {
      header: {
        title: "Get in Touch with TrainZilla",
        subtitle: "Ready to transform your fitness business? Contact our team for personalized support, demo sessions, or answers to any questions about TrainZilla."
      },
      info: {
        title: "Let's Connect",
        desc: "We're here to help you succeed. Reach out to our dedicated team of fitness technology experts who understand the Indian fitness market.",
        email: { title: "Email Support", desc: "Response within 24 hours, Mon-Fri" },
        phone: { title: "Phone Support", desc: "Mon-Fri, 9:00 AM - 7:00 PM IST" },
        location: { title: "Head Office", val: "Pune, Maharashtra, India", desc: "Serving trainers across India" },
        hours: { title: "Business Hours", desc: "Phone and WhatsApp: Mon–Sat, IST working hours" }
      },
      form: {
        title: "Send Us a Message",
        nameLabel: "Full Name *",
        namePlaceholder: "John Doe",
        emailLabel: "Email Address *",
        emailPlaceholder: "john@example.com",
        phoneLabel: "Phone Number",
        phonePlaceholder: "+91 98765 43210",
        typeLabel: "Inquiry Type",
        typePlaceholder: "Select topic",
        types: {
          general: "General Inquiry",
          demo: "Request a Demo",
          pricing: "Pricing/Sales",
          technical: "Technical Support",
          partnership: "Partnership Opportunity"
        },
        subjectLabel: "Subject *",
        subjectPlaceholder: "How can we assist you?",
        messageLabel: "Message *",
        messagePlaceholder: "Please provide details about your inquiry...",
        button: "Send Message",
        buttonSending: "Sending...",
        successHeader: "Message Sent Successfully!",
        successDesc: "Thank you for reaching out to TrainZilla.",
        errors: {
          required: "Please fill in all required fields",
          invalidEmail: "Please enter a valid email address",
          failed: "Failed to submit contact form",
          unexpected: "An unexpected error occurred. Please try again or contact us directly at support@trainzilla.in"
        }
      }
    },
    aboutUsPage: {
      hero: {
        backToHome: "Back to Home",
        badge: "Our Story",
        title: "About TrainZilla",
        subtitle: "We're on a mission to put professional-grade fitness technology in the hands of the world's best coaches."
      },
      mission: {
        badge: "Our Mission",
        title: "Democratizing Fitness Technology",
        description: "Every personal trainer deserves tools that were previously only available to large gym chains and enterprise fitness companies. TrainZilla exists to level that playing field — with AI, great design, and a deep respect for what coaches actually do."
      },
      stats: {
        activeTrainers: "Active Trainers",
        countriesCovered: "Countries Covered",
        clientsManaged: "Clients Managed",
        workoutsCreated: "Workouts Created"
      },
      team: {
        badge: "The Team",
        title: "Built by a Bunch of Misfits",
        subtitle: "We don't have a traditional founding story with Stanford dropouts or Silicon Valley pedigree. We're a scrappy team of tech veterans and fitness obsessives who got tired of watching a broken industry refuse to evolve.",
        anonymous: {
          title: "We're Anonymous by Choice",
          description: "Our identities are less important than what we're building. Behind TrainZilla are engineers who've scaled platforms to millions of users, designers who've rethought industry UX from the ground up, and coaches who've logged thousands of training hours. We come from different corners of tech and fitness — united by one shared frustration: the fitness industry's technology was stuck in 2010.",
          badge: "The product speaks for us"
        },
        traits: {
          tech: { title: "Deep Tech Roots", desc: "Decades of combined experience across software engineering, AI/ML, product design, and scalable architecture. We've shipped products used by millions." },
          fitness: { title: "Fitness Insiders", desc: "We've trained clients, run gyms, coached athletes, and lived the chaos of spreadsheets and WhatsApp group nightmares that fitness professionals deal with daily." },
          builders: { title: "Obsessive Builders", desc: "We don't sleep easy until the product just works. We iterate, break things, rebuild, and relentlessly pursue the right solution — not just the easy one." },
          ruleBreakers: { title: "The Rule-Breakers", desc: "We saw a bloated, expensive, one-size-fits-all fitness tech market and decided to do the opposite. Our design philosophy: powerful for professionals, simple for everyone." }
        }
      },
      challenge: {
        badge: "The Challenge",
        title: "The Gap We Couldn't Ignore",
        subtitle: "We talked to hundreds of trainers globally. The same four problems came up every single time.",
        problems: {
          management: { title: "Client Management Chaos", desc: "Trainers drowning in WhatsApp groups, Excel sheets, and handwritten notebooks", solution: "Unified CRM with automated tracking, communication, and scheduling" },
          revenue: { title: "Revenue Ceiling", desc: "Impossible to scale beyond handful of 1-on-1 clients without burning out", solution: "Digital tools for group sessions, online training, and passive income streams" },
          tools: { title: "No Professional Tools", desc: "Enterprise-grade software existed only for large gym chains — not independent coaches", solution: "Professional-grade AI platform priced for individual trainers at any stage" },
          gaps: { title: "Global Apps, Local Gaps", desc: "Generic apps ignore regional diets, cultural preferences, and vernacular languages", solution: "Global design with multi-lingual support, diverse nutrition databases, and localized payment methods" }
        }
      },
      ecosystem: {
        badge: "The Ecosystem",
        title: "TrainZilla Ecosystem",
        subtitle: "Four interconnected products, one mission — to make fitness professionals unstoppable.",
        items: {
          core: { name: "TrainZilla Core", desc: "Complete trainer management with client tracking, workout planning, and business analytics", features: ["Client Management", "Workout Planning", "Progress Tracking", "Business Analytics"] },
          ai: { name: "TrainZilla AI", desc: "AI engine for personalized workout and nutrition plans powered by real coaching data", features: ["AI Workout Plans", "Smart Nutrition", "Injury Prevention", "Goal Optimization"] },
          mobile: { name: "TrainZilla Mobile", desc: "Native iOS & Android apps for both coaches and clients with real-time sync", features: ["Coach App", "Client App", "Offline Mode", "Push Notifications"] },
          marketplace: { name: "TrainZilla Marketplace", desc: "Discovery platform connecting fitness-seekers with the right trainer, anywhere in the world", features: ["Trainer Discovery", "Service Booking", "Verified Reviews", "Instant Payments"], action: "Visit Marketplace" }
        },
        explore: "Explore"
      },
      values: {
        badge: "Our Values",
        title: "What Drives Us",
        items: {
          india: { title: "Built for the Best", desc: "Every feature ships only if it actually empowers a fitness professional. Global scale, local needs, localized payments — no afterthoughts." },
          empowerment: { title: "Coach Empowerment", desc: "We believe thriving coaches build healthier communities. Everything we build exists to give trainers more time, more income, and more impact." },
          innovation: { title: "Purposeful Innovation", desc: "We use AI and cutting-edge tech not to show off, but to solve visceral, frustrating, real problems that coaches face every single day." }
        }
      },
      cta: {
        title: "Join the Revolution",
        subtitle: "Whether you're a coach ready to scale or just curious what TrainZilla can do — come find out.",
        startTrial: "Start Free Trial",
        getInTouch: "Get in Touch"
      }
    }
  },
} as const;
